import { IsString, Length } from 'class-validator';

export class WidgetViewRequest {
    @IsString()
    @Length(36, 36)
    public slug: string;

    @IsString()
    @Length(3, 255)
    public domain: string;

    constructor(data?: Partial<WidgetViewRequest>) {
        this.slug = data?.slug;
        this.domain = data?.domain;
    }
}
